export default __webpack_public_path__ + "static/media/SummerNew.619fc41f.jpg";